export const DEFAULT_WORKSPACE_IDS: string[] | null | undefined = undefined;

export const ALL_SUBWORKSPACE_ID = 'all';
